var getNextIndex = function getNextIndex(currentIndex, numberOfSlides) {
  var nextIndex = currentIndex === numberOfSlides ? 1 : currentIndex + 1;
  return nextIndex;
};

var getPreviousIndex = function getPreviousIndex(currentIndex, numberOfSlides) {
  var previousIndex = currentIndex === 1 ? numberOfSlides : currentIndex - 1;
  return previousIndex;
};

export { getNextIndex, getPreviousIndex };